import React from 'react';
import {
    X,
    Settings2,
    PieChart,
    BarChart2,
    LineChart,
    Palette,
    Type,
    ChevronDown
} from 'lucide-react';

const StyleChartModal = ({
    isOpen,
    onClose,
    config,
    onChange,
    colorPresets
}) => {
    if (!isOpen) return null;

    // Use provided presets or defaults
    const themes = Object.entries(colorPresets || {}).map(([key, colors]) => ({
        id: key,
        label: (key || '').charAt(0).toUpperCase() + (key || '').slice(1),
        colors: colors
    }));

    return (
        <div className="style-modal-overlay" onClick={onClose}>
            <div className="style-modal-content" style={{ maxWidth: '500px' }} onClick={e => e.stopPropagation()}>
                {/* Header */}
                <div className="style-modal-header">
                    <div className="header-title-group">
                        <div className="icon-box-sm">
                            <Settings2 size={20} />
                        </div>
                        <div className="header-text">
                            <h3>Style Chart</h3>
                            <p>Customize appearance and data settings</p>
                        </div>
                    </div>
                    <button className="btn-close-modal" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <div className="style-modal-body" style={{ padding: '24px' }}>
                    {/* Chart Title */}
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                        <div className="label-wrapper">
                            <Type size={14} />
                            <label>CHART TITLE</label>
                        </div>
                        <input
                            type="text"
                            value={config.title || ''}
                            onChange={(e) => onChange('title', e.target.value)}
                            className="premium-input"
                            placeholder="Enter chart title..."
                        />
                    </div>

                    {/* Chart Type */}
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                        <div className="label-wrapper">
                            <PieChart size={14} />
                            <label>CHART TYPE</label>
                        </div>
                        <div className="select-wrapper" style={{ position: 'relative' }}>
                            <select
                                value={config.type}
                                onChange={(e) => onChange('type', e.target.value)}
                                className="premium-input"
                                style={{ appearance: 'none', width: '100%', cursor: 'pointer' }}
                            >
                                <optgroup label="Bar Charts">
                                    <option value="bar">Bar Chart</option>
                                    <option value="horizontalBar">Horizontal Bar</option>
                                    <option value="stackedBar">Stacked Bar</option>
                                    <option value="groupedBar">Grouped Bar</option>
                                </optgroup>
                                <optgroup label="Line Charts">
                                    <option value="line">Line Chart</option>
                                    <option value="multiLine">Multi-Line</option>
                                    <option value="area">Area Chart</option>
                                    <option value="stackedArea">Stacked Area</option>
                                </optgroup>
                                <optgroup label="Circular Charts">
                                    <option value="pie">Pie Chart</option>
                                    <option value="donut">Donut Chart</option>
                                    <option value="polarArea">Polar Area</option>
                                </optgroup>
                                <optgroup label="Advanced Charts">
                                    <option value="combo">Combo (Bar + Line)</option>
                                    <option value="scatter">Scatter Plot</option>
                                    <option value="bubble">Bubble Chart</option>
                                    <option value="radar">Radar Chart</option>
                                </optgroup>
                            </select>
                            <ChevronDown size={16} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', opacity: 0.5 }} />
                        </div>
                    </div>

                    {/* Color Theme */}
                    <div className="form-group">
                        <div className="label-wrapper">
                            <Palette size={14} />
                            <label>COLOR THEME</label>
                        </div>
                        <div className="select-wrapper" style={{ position: 'relative' }}>
                            <select
                                value={config.theme}
                                onChange={(e) => onChange('theme', e.target.value)}
                                className="premium-input"
                                style={{ appearance: 'none', width: '100%', cursor: 'pointer' }}
                            >
                                {themes.map((theme) => (
                                    <option key={theme.id} value={theme.id}>{theme.label}</option>
                                ))}
                            </select>
                            <ChevronDown size={16} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', opacity: 0.5 }} />
                        </div>

                        {/* Selected Theme Color Preview */}
                        {config.theme && themes.find(t => t.id === config.theme) && (
                            <div className="theme-preview-strip" style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
                                {themes.find(t => t.id === config.theme).colors.map((color, i) => (
                                    <div
                                        key={i}
                                        style={{
                                            backgroundColor: color,
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '50%',
                                            border: '2px solid var(--glass-border)',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}
                                        title={color}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="style-modal-footer">
                    <button onClick={onClose} className="btn-secondary" style={{ padding: '10px 24px' }}>
                        Cancel
                    </button>
                    <button onClick={onClose} className="btn-primary" style={{ padding: '10px 24px' }}>
                        Apply Styles
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StyleChartModal;
